export var ReplicatorActivityLevel;
(function (ReplicatorActivityLevel) {
    // eslint-disable-next-line
    ReplicatorActivityLevel[ReplicatorActivityLevel["STOPPED"] = 0] = "STOPPED";
    // eslint-disable-next-line
    ReplicatorActivityLevel[ReplicatorActivityLevel["OFFLINE"] = 1] = "OFFLINE";
    // eslint-disable-next-line
    ReplicatorActivityLevel[ReplicatorActivityLevel["CONNECTING"] = 2] = "CONNECTING";
    // eslint-disable-next-line
    ReplicatorActivityLevel[ReplicatorActivityLevel["IDLE"] = 3] = "IDLE";
    // eslint-disable-next-line
    ReplicatorActivityLevel[ReplicatorActivityLevel["BUSY"] = 4] = "BUSY";
})(ReplicatorActivityLevel || (ReplicatorActivityLevel = {}));
//# sourceMappingURL=replicator-activity-level.js.map